import { ArrowRightIOS } from "../../../assets/icons";
import styles from "./SelectableItem.module.scss";

interface SelectableItemProps {
	leftIcon?: React.ReactNode;
	/** Default navigation arrow. Use rightContent to supply a custom widget (e.g. SwitchButton) with no fallback arrow. */
	rightIcon?: React.ReactNode;
	/** Replaces rightIcon with no default arrow — use for card variant with a switch or other widget. */
	rightContent?: React.ReactNode;
	title: string;
	subtitle?: string;
	showBadge?: boolean;
	hideBottomBorder?: boolean;
	onClick?: () => void;
	/** Card variant — renders a full border + rounded corners instead of a bottom border. */
	borderColor?: string;
	borderRadius?: string | number;
	fontSize?: number;
	padding?: string;
	textColor?: string;
	backgroundColor?: string;
}

export const SelectableItem = ({
	leftIcon,
	rightIcon,
	rightContent,
	title,
	subtitle,
	showBadge,
	hideBottomBorder = false,
	onClick,
	borderColor,
	borderRadius,
	fontSize,
	padding,
	textColor,
	backgroundColor,
}: SelectableItemProps) => {
	const isCardVariant = !!(borderColor || borderRadius || backgroundColor);
	const inlineStyle: React.CSSProperties = {
		...(borderColor ? { border: `1px solid ${borderColor}`, borderBottom: `1px solid ${borderColor}` } : {}),
		...(borderRadius ? { borderRadius: typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius } : {}),
		...(padding ? { padding } : {}),
		...(backgroundColor ? { backgroundColor } : {}),
	};
	const titleStyle: React.CSSProperties = {
		...(fontSize ? { fontSize: `${fontSize}px` } : {}),
		...(textColor ? { color: textColor } : {}),
	};

	const classNames = [
		styles.item,
		!hideBottomBorder && !isCardVariant ? "" : styles["hide-bottom-border"],
	].filter(Boolean).join(" ");

	return (
		<button type="button" className={classNames} style={inlineStyle} onClick={onClick}>
			{leftIcon && <span className={styles.itemIcon}>{leftIcon}</span>}
			<span className={styles.itemContent}>
				<span className={styles.itemTitle} style={titleStyle}>{title}</span>
				{subtitle && <span className={styles.itemSubtitle}>{subtitle}</span>}
			</span>
			{showBadge && <span className={styles.badge}>New</span>}
			{rightContent !== undefined ? rightContent : (rightIcon ?? <ArrowRightIOS />)}
		</button>
	);
};
